var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustumertablearrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9103 10L9.96289 10.8315L14.8682 15.1304L9.96961 19.4352L10.9171 20.2667L16.286 15.5491C16.5465 15.3191 16.5465 14.9476 16.286 14.7176L10.9103 10Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4289 10L14.4814 10.8315L19.3867 15.1304L14.4882 19.4352L15.4356 20.2667L20.8046 15.5491C21.0651 15.3191 21.0651 14.9476 20.8046 14.7176L15.4289 10Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustumertablearrow);
export default __webpack_public_path__ + "static/media/Custumertablearrow.5f379590961544e8a14cd1a4fb3d6d51.svg";
export { ForwardRef as ReactComponent };